<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
      <div class="top">
        <div class="header" :style="{'margin-bottom': isMT ? '60px' : ''}">
          <a href="/">
            <!-- <img src="~@/assets/logo2.png" class="logo" alt="logo"> -->
            <span class="title">{{isMT ? '客户服务平台' : '中农网会员平台'}}</span>
          </a>
        </div>
        <div class="desc" v-if="!isMT">
          历经九年的成长与变革，秉承“大生意，更容易”
        </div>
      </div>

      <route-view></route-view>

      <!-- <div class="MT_tip" v-if="isMT">
        新平台请使用交易密码登录<br />如需查询2019年7月29日前数据请进入
        <a href="http://61.138.200.20:8080/emp/"
        target="_blank" class="link">旧客户服务平台</a>
      </div> -->
      <div class="MT_tip" v-if="isMT">
        <!-- <span>昆明客户 如需查询2019年7月29日前数据请进入 <a href="http://61.138.200.20:8080/emp/" target="_blank" class="link">旧客户服务平台(昆明)</a></span><br/> -->
        <!-- <span>柳州客户 如需查询2019年10月25日前数据请进入 <a href="http://member.msweet.com.cn:81/member/index" target="_blank" class="link">旧客户服务平台(柳州)</a></span> -->
      </div>

      <div class="footer">
        <!-- <div class="links">
          <a href="_self">帮助</a>
          <a href="_self">隐私</a>
          <a href="_self">条款</a>
        </div> -->
        <div class="copyright">
          © 2013 深圳市中农网有限公司. SHENZHEN SINOAGRI E-COMMERCE CO.,LTD. 粤ICP备17148641号-1
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteView from '@/components/layouts/route-view'

export default {
  name: 'UserLayout',
  components: { RouteView },
  data () {
    return {
      device: '',
      isMT: false // 是否是沐甜市场
    }
  },
  watch: {
    '$route.query.marketId' (val) {
      this.isMT = val === '000'
    }
  },
  mounted () {
    document.body.classList.add('userLayout')
    this.isMT = this.$route.query.marketId === '000' // 根据路由参数判断当前是否是沐甜市场
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="scss" scoped>
  #userLayout.user-layout-wrapper {
    height: 100%;

    .container {
      width: 100%;
      min-height: 100%;
      background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
      background-size: 100%;
      padding: 110px 0 144px;
      position: relative;

      a {
        text-decoration: none;
      }

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 33px;
            color: rgba(0, 0, 0, .85);
            font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .MT_tip{
        text-align: center;
        line-height: 30px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
        .link{
          color: #1B9AF7;
          cursor: pointer;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }
  }
</style>
